module.exports = __webpack_public_path__ + "static/media/IMG_3888.78e47ccd.JPG";